import React from "react";
import PosCustomIcon from "../../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import "./CurrentSessionCard.css";

const CurrentSessionCard = ({icon, title, value}) => {
  return (
    <div className="currentSessionCardContainer">
      <div className="sessionCardHeading">
        <p>{title}</p>
        <PosCustomIcon image={icon} height={"20px"} width={"20px"} />
      </div>
      <p className="sessionCardvalue">{value}</p>
    </div>
  );
};

export default CurrentSessionCard;
